module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_LHD_THUMB.6ed72759.jpg";